import TranslatorsService from '@/hexapla-core/domains/resources/translators'
import { Translator, TranslatorRelationship } from '@/hexapla-core/domains/resources'

export interface UseTranslatorsService {
  listTranslators: () => Promise<Translator[]>
  listTranslatorRelationships: () => Promise<TranslatorRelationship[]>
  showTranslator: (id: number) => Promise<Translator>
  updateTranslator: (tr: Translator) => Promise<Translator>
  deleteTranslator: (id: number) => Promise<void>
}

export function useTranslatorsService(url: string): UseTranslatorsService {
  return {
    listTranslators: () => TranslatorsService.index(url),
    listTranslatorRelationships: () => TranslatorsService.relationships(url),
    showTranslator: (id: number) => TranslatorsService.show(url, id),
    updateTranslator: (tr: Translator) => TranslatorsService.update(url, tr),
    deleteTranslator: (id: number) => TranslatorsService.destroy(url, id),
  }
}
